import { BoxIcon } from '@grupoboticario/flora-react-icons';
import Item from './Item';
import { Items } from './Summary.components.styles';
import { SUMMARY_COMPONENTS_CONST } from './Summary.components.d';
import { formatTotalUnitPlural } from './helpers';
import type { SummaryItemProps } from './Summary.components.d';

const ItemsBase = ({ items = [] }: SummaryItemProps) => (
  <Items.Component data-testid={SUMMARY_COMPONENTS_CONST.ITEMS_TEST_ID}>
    <Items.Title>
      <BoxIcon size={24} />
      Comprando {formatTotalUnitPlural(items.length)}
    </Items.Title>

    {items.map(({ image, name, price, priceTotal, productCode, quantity }) => (
      <Items.Card key={productCode} radius="rounded">
        <Item
          image={image}
          name={name}
          price={price}
          priceTotal={priceTotal}
          productCode={productCode}
          quantity={quantity}
        />
      </Items.Card>
    ))}
  </Items.Component>
);

export default ItemsBase;
